@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container-fluid mb-5 px-3">
        <div class="w-fit">
            <app-back-button routerLink="/equifax-lookup" component="Guest Search"></app-back-button>
        </div>
        <div class="row justify-content-center">
            <div class="my-2 d-flex">
                <h1>Equifax Results For:  &nbsp;{{ guest.firstName }} {{ guest.lastName }}</h1>
            </div>
        </div>
        <mat-card class="mt-3 pb-5">
            <div class="row my-3 justify-content-center">
                <div class="col-3 d-flex flex-column pl-5">
                    <div class="item-key detail-label">Decision</div>
                </div>
                <div class="col-5 d-flex flex-column pr-5">
                    <div class="trust-decision text-center p-1" [ngClass]="getDecisionColor(guest[0].decision)">
                        {{ guest[0].decision }}
                    </div>
                    <div class="d-flex">
                        <span class="item-value mx-2">( Last Updated</span>
                        <span class="item-value">{{ guest[0].timestamp | date:'short' }} )</span>
                    </div>
                </div>
            </div>
            <div *ngIf="deniedTrustArray.length > 0" class="row my-3 justify-content-center">
                <div class="col-3 d-flex flex-column pl-5">
                    <div class="item-value">DENIED TRUST(S): </div>
                </div>
                <div class="col-5 d-flex flex-column pr-5">
                    <div class="red text-center p-1">
                        {{ deniedTrustArray }}
                    </div>
                </div>
            </div>
            <hr>
            <!-- IDENTITY -->
            <div class="row my-2">
                <div class="col d-flex flex-column">
                    <app-guest-identity-result-card class="col-12" [guest]="guest"></app-guest-identity-result-card>
                </div>
            </div>
            <!-- ADDRESS -->
            <div class="row my-2">
                <div class="col d-flex flex-column">
                    <app-guest-address-result-card class="col-12" [guest]="guest"></app-guest-address-result-card>
                </div>
            </div>
            <!-- DOB -->
            <div class="row my-2">
                <div class="col d-flex flex-column">
                    <app-guest-dob-result-card class="col-12" [guest]="guest"></app-guest-dob-result-card>
                </div>
            </div>
            <!-- SSN -->
            <!-- <div class="row my-2">
                <div class="col d-flex flex-column">
                    <app-guest-ssn-result-card class="col-12" [guest]="guest"></app-guest-ssn-result-card>
                </div>
            </div> -->
            <!-- PHONE -->
            <div class="row my-2">
                <div class="col d-flex flex-column">
                    <app-guest-phone-result-card class="col-12" [guest]="guest"></app-guest-phone-result-card>
                </div>
            </div>
            <!-- EMAIL -->
            <div class="row my-2">
                <div class="col d-flex flex-column">
                    <app-guest-email-result-card class="col-12" [guest]="guest"></app-guest-email-result-card>
                </div>
            </div>
            <!-- DEVICE -->
            <div class="row my-2">
                <div class="col d-flex flex-column">
                    <app-guest-device-result-card class="col-12" [guest]="guest"></app-guest-device-result-card>
                </div>
            </div>
        </mat-card>
    </div>
}